import "./slider-gallery-training-cta";
